module.exports = __webpack_public_path__ + "static/media/PricingDQWorkspace4.c61e31b5.png";